const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.002 512.002",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M413.001 420.001v77.001l-40-14.999-40 14.999-40-14.999-40 14.999-40-14.999-40 14.999-40-14.999-40 14.999V53M55.001 15h318.997c21.482 0 39.003 17.521 39.003 39.003v140.998",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 29.9999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "white",
    strokeWidth: 29.9999,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "white",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.001 15c21.45 0 39 17.55 39 39v117h-78V54c0-21.45 17.55-39 39-39zM153.001 135.002h121M334.001 135.002h19M153.001 195.003h121M153.001 255.002h121M153.001 315.002h111M153.001 75.001h121M334.001 75.001h19M153.001 375.001h121",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 29.9999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "white",
    strokeWidth: 29.9999,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "white",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.501,
    cy: 307.5,
    r: 114.5,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 29.9999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    transform: "rotate(-45.001 382.5 307.506)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "white",
    strokeWidth: 29.9999,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "white",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.512 260.864h-18.183c-11.962 0-21.706 9.724-21.706 21.782 0 8.426 4.462 15.646 11.999 19.414l23.197 11.599",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 29.9999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "white",
    strokeWidth: 29.9999,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "white",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.49 354.135h18.183c11.962 0 21.706-9.724 21.706-21.782 0-8.426-4.462-15.646-11.998-19.414l-23.198-11.599M382.501 260.866v-12.905M382.501 367.04v-12.905",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 29.9999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "white",
    strokeWidth: 29.9999,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    "data-original": "white",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon8.9de8ae8a2920c86d518712612f9b6064.svg";
export { ForwardRef as ReactComponent };